/**
 * STEMO: Snap add-to-cart and cart quantities to pack sizes (25, 50, … / 10, 20, …).
 */
(function () {
  function packFor(form) {
    const attrEl = form && form.querySelector("[data-stemo-pack-qty]");
    const attr = (form && form.getAttribute("data-stemo-pack-qty")) || (attrEl && attrEl.getAttribute("data-stemo-pack-qty"));
    const fromForm = parseInt(attr, 10);
    if (fromForm > 1) return fromForm;

    const idInput = form && form.querySelector('[name="id"]');
    const variantId = idInput && idInput.value;
    const map = window.StemoPackQty || {};
    const fromMap = parseInt(map[variantId], 10);
    return fromMap > 1 ? fromMap : 0;
  }

  function snap(qty, pack) {
    const n = parseInt(qty, 10);
    if (!pack || pack < 2) return n > 0 ? n : 1;
    if (!n || n < pack) return pack;
    return Math.round(n / pack) * pack || pack;
  }

  function isValidQty(qty, pack) {
    const n = parseInt(qty, 10);
    return pack < 2 || (n >= pack && n % pack === 0);
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const pack = packFor(form);
      if (!pack) return;

      let qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput && form.id) {
        qtyInput = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      }
      if (!qtyInput) {
        const hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "quantity";
        hidden.value = String(pack);
        form.appendChild(hidden);
        return;
      }
      qtyInput.value = String(snap(qtyInput.value, pack));
    },
    true
  );

  async function cartHasInvalidPackQty() {
    const map = window.StemoPackQty || {};
    const keys = Object.keys(map).filter((k) => parseInt(map[k], 10) > 1);
    if (!keys.length) return false;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const nativeFetch = window.__stemoNativeFetch || window.fetch.bind(window);
    const response = await nativeFetch(`${root}cart.js`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!response.ok) return false;
    const cart = await response.json();
    return (cart.items || []).some((item) => {
      const pack = parseInt(map[String(item.variant_id)], 10);
      return pack > 1 && !isValidQty(item.quantity, pack);
    });
  }

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const submitter = event.submitter;
      if (!submitter || submitter.name !== "checkout") return;

      if (await cartHasInvalidPackQty()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const msg =
          (window.themeVariables &&
            window.themeVariables.strings &&
            window.themeVariables.strings.packQtyError) ||
          "Some items must be bought in pack quantities.";
        window.alert(msg);
      }
    },
    true
  );
})();
